import { render, staticRenderFns } from "./DialogContent.vue?vue&type=template&id=77e4399c&scoped=true&"
import script from "./DialogContent.vue?vue&type=script&lang=ts&"
export * from "./DialogContent.vue?vue&type=script&lang=ts&"
import style0 from "./DialogContent.vue?vue&type=style&index=0&id=77e4399c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e4399c",
  null
  
)

export default component.exports